import React, { useState } from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import { validate, validators } from 'validate-redux-form';
import PropTypes from 'prop-types';
import NavbarModulo from '../../components/NavbarModulo';
import {
    renderField,
    renderFieldCheck
} from "../../Utils/renderField/renderField";

function PilotoForm(props) {
    const { handleSubmit, crear, modulo } = props;
    const editar = window.location.href.includes('editar');
    let titulo = editar ? 'Modificar encargado' : 'Crear encargado';
    let disabled = false;
    if (crear === false && editar === false) {
        disabled = true;
        titulo = 'Ver encargado'
    }
    let autoFocus = true;
    const [activo, setActivo] = useState(true);

    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    
    return (
        <div>
            <NavbarModulo
                modulo={modulo}
                titulo={titulo}
            />
            <br />
            <div className="mb-4 card card-small text-white bg-dark mb-3">
                <div className="p-0 pt-3 d-flex flex-column flex-md-row">
                    <div className="d-flex flex-column flex-1 mx-4">
                        <div className='row mb-2'>
                            <div className='col-6'>
                                <Field
                                    autoFocus={autoFocus}
                                    name="nombre"
                                    placeholder="Nombre"
                                    className="form-control"
                                    component={renderField}
                                    disabled={disabled}
                                    msj="Nombre"
                                />
                            </div>
                            <div className='col-4 mt-3'>
                                {editar === true &&
                                    <Field
                                        disabled={disabled}
                                        name="activo"
                                        label="Activo"
                                        component={renderFieldCheck}
                                    />
                                }
                                {crear === false && editar === false &&
                                    <Field
                                        disabled={disabled}
                                        name="activo"
                                        label="Activo"
                                        component={renderFieldCheck}
                                    />
                                }
                            </div>
                            <div className='d-flex flex-row mt-3'>
                                {disabled == false &&
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        onClick={handleSubmit}
                                    >
                                        {editar ? 'Modificar' : 'Guardar'}
                                    </button>
                                }
                                <a
                                    href={`/#/produccion/${id_emp[5]}/piloto`}
                                    className='btn btn-secondary mb-3'
                                >
                                    Regresar
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

PilotoForm.propTypes = {
    handleSubmit: PropTypes.func,
    crear: PropTypes.bool,
    lectura: PropTypes.object,
    modulo: PropTypes.object
};

export default reduxForm({
    form: 'FormPiloto',
    validate: (data) => {
        return validate(data, {
            nombre: validators.exists()('Este campo es requerido'),
        });
    },
})(PilotoForm);
